'use strict';
const angular = require('angular');

export class reasonFormComponent {
  /*@ngInject*/
  constructor() {
  }

  $onInit = function () {
    //this.config = this.resolve.config;
  };

  ok() {
    this.close({$value: this.reason});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduApp.reasonForm', [])
  .component('reasonForm', {
    template: require('./reason-form.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: reasonFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/reason-form/reason-form.component.js